import {
  UploadDocumentDocumentFormatEnum,
  UploadDocumentDocumentTagEnum,
} from "../../../../../../../services";
// PATIENT_REGISTRATION_FORM" | "INSURANCE_INFORMATION" | "CONSENT_FORM" | "ID_AND_PROOF_OF_ADDRESS" | "PROGRESS_NOTE" | "LAB_REPORT" | "IMAGING_REPORT" | "CONSULTATION_NOTE" | "SURGERY_REPORT" | "DISCHARGE_SUMMARIES" | "MEDICATION_LIST" | "REFERRAL_LETTER" | "AUTHORIZATION_LETTER" | "FAX"
export const DOCUMENT_TAGS = [
  { label: "Patient Registration Form", value: "PATIENT_REGISTRATION_FORM" },
  { label: "Insurance Information", value: "INSURANCE_INFORMATION" },
  { label: "Consent Form", value: "CONSENT_FORM" },
  { label: "Id And Proof Of Address", value: "ID_AND_PROOF_OF_ADDRESS" },
  { label: "Progress Note", value: "PROGRESS_NOTE" },
  { label: "Lab Report", value: "LAB_REPORT" },
  { label: "Imaging Report", value: "IMAGING_REPORT" },
  { label: "Consultation Note", value: "CONSULTATION_NOTE" },
  { label: "Surgery Report", value: "SURGERY_REPORT" },
  { label: "Discharge Summary", value: "DISCHARGE_SUMMARIES" },
  { label: "Medication List", value: "MEDICATION_LIST" },
  { label: "Referral Letter", value: "REFERRAL_LETTER" },
  { label: "Authorization Letter", value: "AUTHORIZATION_LETTER" },
  { label: "Fax", value: "FAX" },
];
export const DOCUMENT_TABLE_MAPPER: Record<string, string> = {
  PATIENT_REGISTRATION_FORMS: "Patient Registration Forms",
  INSURANCE_INFORMATION: "Insurance Information",
  CONSENT_FORM: "Consent Form",
  ID_AND_PROOF_OF_ADDRESS: "Id And Proof Of Address",
  PROGRESS_NOTE: "Progress Note",
  LAB_REPORT: "Lab Report",
  IMAGING_REPORT: "Imaging Report",
  CONSULTATION_NOTE: "Consultation Note",
  SURGERY_REPORT: "Surgery Report",
  DISCHARGE_SUMMARIES: "Discharge Summary",
  MEDICATION_LIST: "Medication List",
  REFERRAL_LETTER: "Referral Letter",
  AUTHORIZATION_LETTER: "Authorization Letter",
  FAX: "Fax",
};

export type DocumentForm = {
  name: string;
  documentTag?: UploadDocumentDocumentTagEnum;
  documentFormat: UploadDocumentDocumentFormatEnum;
  file?: File;
  documentDate?: string;
  documentDescription?: string;
};

export const DOCUMENT_INITIAL_VALUE: DocumentForm = {
  name: "",
  documentTag: undefined,
  documentFormat: "CSV",
  file: undefined,
  documentDescription: "",
  documentDate: "",
};

export const DOCUMENT_FORMAT_MAPPER: Record<string, string> = {
  "application/pdf": "PDF",
  "application/msword": "MS_WORD",
  "application/zip": "ZIP",
  "application/x-gzip": "X_GZIP",
  "application/x-zip-compressed": "ZIP",
  "application/x-compressed": "X_COMPRESSED",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "XLSX",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    "DOCX",
  "text/rtf": "RTF",
  "text/plain": "PLAIN",
  "image/jpeg": "JPEG_IMAGE",
  "image/png": "PNG_IMAGE",
  "image/gif": "GIF_IMAGE",
  "image/bmp": "BMP_IMAGE",
  "image/webp": "WEBP_IMAGE",
  "image/svg+xml": "SVG_IMAGE",
  "audio/mpeg": "MPEG_AUDIO",
  "video/mp4": "MP4",
  "binary/octet-stream": "OTHER",
  "text/csv": "CSV",
};

export const DOCUMENT_REV_MAPPER: Record<string, string> = {
  PDF: "PDF",
  MS_WORD: "MS Word",
  ZIP: "ZIP",
  X_GZIP: "X-GZIP",
  X_COMPRESSED: "X-Compressed",
  DOCX: "Document",
  RTF: "Text",
  PLAIN: "Text",
  JPEG_IMAGE: "JPEG",
  PNG_IMAGE: "PNG",
  GIF_IMAGE: "GIF",
  BMP_IMAGE: "BMP",
  WEBP_IMAGE: "WebP",
  SVG_IMAGE: "SVG",
  MPEG_AUDIO: "MPEG Audio",
  OTHER: "Other",
  CSV: "CSV",
  XLSX: "Excel",
  MP4: "MP4",
};

type ReturnDocType = "pdf" | "img" | "text" | "video";

export const DOC_TYPE_MAPPER: Record<string, ReturnDocType> = {
  PDF: "pdf",
  SVG_IMAGE: "img",
  WEBP_IMAGE: "img",
  BMP_IMAGE: "img",
  GIF_IMAGE: "img",
  PNG_IMAGE: "img",
  JPEG_IMAGE: "img",
  MP4: "video",
  PLAIN: "text",
};
